import Vue from 'vue';
import Message from './Message/Message';
import Popup from './Popup/Popup';
import Loader, { LoaderDirective } from './Loader/Loader';
import Counter, { CounterDirective } from './Counter/Counter';
import Help, { HelpDirective } from './Help/Help';
import SAutocomplete from './Form/Autocomplete/SAutocomplete.vue';
import SAutocompleteOption from './Form/Autocomplete/SAutocompleteOption.vue';
import SApolloAutocomplete from './Form/Autocomplete/SApolloAutocomplete.vue';
import SMessage from './Message/SMessage.vue';
import SButton from './SButton.vue';
import SProgress from './SProgress.vue';
import SSuccess from './SSuccess.vue';
import SWarning from './SWarning.vue';
import SCheckbox from './Form/SCheckbox.vue';
import SDatepicker from './Form/SDatepicker.vue';
import SDatetimepicker from './Form/SDatetimepicker.vue';
import SExpandable from './SExpandable.vue';
import SLoader from './Loader/SLoader.vue';
import SInfiniteLoader from './Loader/SInfiniteLoader.vue';
import SCounter from './Counter/SCounter.vue';
import SSelect from './Form/Select/SSelect.vue';
import SForm from './Form/SForm.vue';
import SInput from './Form/SInput.vue';
import SIntegerInput from './Form/SIntegerInput.vue';
import SAmountInput from './Form/SAmountInput.vue';
import SSignedAmountInput from './Form/SSignedAmountInput.vue';
import SPopup from './Popup/SPopup.vue';
import SRadio from './Form/SRadio.vue';
import STextarea from './Form/STextarea.vue';
import SUpload from './Form/SUpload.vue';
import SMultipleAttachments from './Form/SMultipleAttachments.vue';
import SDropdown from './SDropdown.vue';
import SNavMenu from './Menu/SNavMenu.vue';
import SMenuItem from './Menu/SMenuItem.vue';
import SColumn from './Table/SColumn.vue';
import STable from './Table/STable.vue';
import SApolloTable from './Table/SApolloTable.vue';
import SHelp from './Help/SHelp.vue';
import SList from './List/SList.vue';
import SListRow from './List/SListRow.vue';
import SListKey from './List/SListKey.vue';
import SListValue from './List/SListValue.vue';
import SBlender from './SBlender.vue';
import WindowEventListener from './WindowEventListener.vue';
import SImageCarousel from './SImageCarousel.vue';

Vue.component('SForm', SForm);
Vue.component('SAutocomplete', SAutocomplete);
Vue.component('SAutocompleteOption', SAutocompleteOption);
Vue.component('SApolloAutocomplete', SApolloAutocomplete);
Vue.component('SInput', SInput);
Vue.component('SAmountInput', SAmountInput);
Vue.component('SIntegerInput', SIntegerInput);
Vue.component('SSignedAmountInput', SSignedAmountInput);
Vue.component('SButton', SButton);
Vue.component('SProgress', SProgress);
Vue.component('SSuccess', SSuccess);
Vue.component('SWarning', SWarning);
Vue.component('SCheckbox', SCheckbox);
Vue.component('SDatepicker', SDatepicker);
Vue.component('SDatetimepicker', SDatetimepicker);
Vue.component('SExpandable', SExpandable);
Vue.component('SLoader', SLoader);
Vue.component('SInfiniteLoader', SInfiniteLoader);
Vue.component('SCounter', SCounter);
Vue.component('SRadio', SRadio);
Vue.component('SSelect', SSelect);
Vue.component('SPopup', SPopup);
Vue.component('SMessage', SMessage);
Vue.component('STable', STable);
Vue.component('SApolloTable', SApolloTable);
Vue.component('SColumn', SColumn);
Vue.component('STextarea', STextarea);
Vue.component('SUpload', SUpload);
Vue.component('SMultipleAttachments', SMultipleAttachments);
Vue.component('SDropdown', SDropdown);
Vue.component('SNavMenu', SNavMenu);
Vue.component('SMenuItem', SMenuItem);
Vue.component('SHelp', SHelp);
Vue.component('SList', SList);
Vue.component('SListRow', SListRow);
Vue.component('SListKey', SListKey);
Vue.component('SListValue', SListValue);
Vue.component('SBlender', SBlender);
Vue.component('WindowEventListener', WindowEventListener);
Vue.component('SImageCarousel', SImageCarousel);

Vue.prototype.$sPopup = Popup;
Vue.prototype.$sMessage = Message;
Vue.prototype.$sLoader = Loader;
Vue.prototype.$sCounter = Counter;
Vue.prototype.$sHelp = Help;

Vue.directive('s-loader', LoaderDirective);
Vue.directive('s-counter', CounterDirective);
Vue.directive('s-help', HelpDirective);
